import { FormControl, InputLabel, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectProps } from "@mui/material/Select";
import { ForwardRefRenderFunction, forwardRef, memo } from "react";
import { useTranslation } from "react-i18next";

export interface GenDropDownItem {
  label: string;
  value: string;
}

export type GenDropDownProps = Omit<SelectProps, "error"> & {
  items: GenDropDownItem[];
  placeholder?: string;
  error?: string;
};

export const GenDropDown: ForwardRefRenderFunction<
  SelectProps,
  GenDropDownProps
> = (props, ref) => {
  const {
    required,
    items,
    placeholder,
    defaultValue,
    label,
    error,
    labelId,
    ...otherProps
  } = props;
  const { t } = useTranslation();

  return (
    <FormControl
      fullWidth
      margin="none"
      sx={{
        marginTop: 1,
        marginBottom: 1,
      }}
    >
      <InputLabel id={`dropdown-lable-${labelId}`}>
        {label}
        {required ? (
          <Typography component="span" color="error">
            *
          </Typography>
        ) : (
          ""
        )}
      </InputLabel>
      <Select
        fullWidth
        id={`dropdown-lable-${labelId}`}
        required={required}
        defaultValue={defaultValue}
        error={!!error?.length}
        label={label}
        {...otherProps}
      >
        {placeholder?.length ? (
          <MenuItem key={`default-choice`} color="secondary.light">
            {placeholder || ""}
          </MenuItem>
        ) : null}
        {items.map(({ label, value }, i) => (
          <MenuItem key={`${label}-${value}-choice-${i}`} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
      {error?.length && (
        <Typography
          variant="caption"
          color="error"
          marginTop={0.5}
          marginLeft={1.5}
        >
          {t(error)}
        </Typography>
      )}
    </FormControl>
  );
};

export default memo(forwardRef(GenDropDown));
